export const originOptions = [
    { value: "VISITA", label: "VISITA" },
    { value: "GABINETE", label: "GABINETE" },
    { value: "MULTA", label: "MULTA" },
    { value: "OBRA", label: "OBRA" },
    { value: "CUOTAS", label: "CUOTAS" },
    { value: "VERIFICACIÓN", label: "VERIFICACIÓN" },
    { value: "INSPECCIÓN", label: "INSPECCIÓN" },
    { value: "PAMA", label: "PAMA" },
    { value: "REQUERIMIENTO", label: "REQUERIMIENTO" },
    { value: "Otro", label: "Otro" },
];
